(function () {
  const root = document.getElementById("social-share-root");
  if (!root) {
    return;
  }

  const POSTER = {
    width: 1080,
    height: 1920,
    portraitBox: { x: 390, y: 310, w: 300, h: 300 },
  };

  const CROP_CANVAS_SIZE = 320;
  const MAX_IMAGE_DIMENSION = 2400;

  const elements = {
    form: document.getElementById("social-share-form"),
    firstName: document.getElementById("social-share-first-name"),
    lastName: document.getElementById("social-share-last-name"),
    nameEditor: document.querySelector(".social-share-name-editor"),
    artBoard: document.getElementById("social-share-art-board"),
    photoHotspot: document.getElementById("social-share-photo-hotspot"),
    photoSheet: document.getElementById("social-share-photo-sheet"),
    fileInput: document.getElementById("social-share-photo-input"),
    captureInput: document.getElementById("social-share-capture-input"),
    uploadButton: document.getElementById("social-share-upload-button"),
    cameraButton: document.getElementById("social-share-camera-button"),
    zoom: document.getElementById("social-share-zoom"),
    resetCrop: document.getElementById("social-share-reset-crop"),
    download: document.getElementById("social-share-download"),
    share: document.getElementById("social-share-share"),
    copy: document.getElementById("social-share-copy"),
    alert: document.getElementById("social-share-alert"),
    status: document.getElementById("social-share-status"),
    previewCanvas: document.getElementById("social-share-canvas"),
    cropCanvas: document.getElementById("social-share-crop-canvas"),
    cropHint: document.getElementById("social-share-crop-hint"),
    cameraSheet: document.getElementById("social-share-camera-sheet"),
    cameraVideo: document.getElementById("social-share-camera-video"),
    captureButton: document.getElementById("social-share-capture-button"),
  };

  if (
    !elements.form ||
    !elements.firstName ||
    !elements.lastName ||
    !elements.previewCanvas ||
    !elements.cropCanvas
  ) {
    return;
  }

  const previewCtx = elements.previewCanvas.getContext("2d");
  const cropCtx = elements.cropCanvas.getContext("2d");
  const nameFitCtx = document.createElement("canvas").getContext("2d");

  const messages = {
    firstNameRequired: root.dataset.firstNameRequired || "First name is required.",
    lastNameRequired: root.dataset.lastNameRequired || "Last name is required.",
    photoRequired: root.dataset.photoRequired || "Student photo is required.",
    imageLoadError:
      root.dataset.imageLoadError ||
      "We could not read that image. Please choose another photo.",
    cameraPermissionError:
      root.dataset.cameraPermissionError ||
      "Camera permission was denied. You can upload a photo instead.",
    cameraUnavailable:
      root.dataset.cameraUnavailable ||
      "Camera is not available on this device. You can upload a photo instead.",
    genericError: root.dataset.genericError || "Something went wrong. Please try again.",
    shareUnavailable:
      root.dataset.shareUnavailable ||
      "Sharing is not available here, so the PNG was downloaded instead.",
    copySuccess: root.dataset.copySuccess || "Image copied to clipboard.",
    copyUnavailable:
      root.dataset.copyUnavailable ||
      "Clipboard copy is not available in this browser.",
    downloadReady: root.dataset.downloadReady || "PNG ready.",
  };

  const assetsBase =
    root.dataset.assetsBase || "/assets/zoni_edu/assets/img/social-share/";

  const assetPaths = {
    background: `${assetsBase}poster-background.png`,
    logo: `${assetsBase}zonilive-logo.svg`,
    ai: `${assetsBase}ai-graphic.png`,
    verifiedOutline: `${assetsBase}verified-outline.svg`,
    verifiedChip: `${assetsBase}verified-chip.png`,
  };

  const state = {
    firstName: "",
    lastName: "",
    image: null,
    imageWidth: 0,
    imageHeight: 0,
    crop: {
      x: 0,
      y: 0,
      scale: 1,
    },
    assets: {},
    renderPending: false,
    exporting: false,
    cameraStream: null,
    cropHintDismissed: false,
    cropHintTimer: null,
    pointer: {
      active: false,
      lastX: 0,
      lastY: 0,
    },
  };

  let assetsPromise = loadStaticAssets();
  let nameResizeObserver = null;

  init();

  function init() {
    bindEvents();
    updateCopyAvailability();
    updateCropControls();
    renderCropPreview();
    fitNameInputs();
    scheduleRender();

    assetsPromise
      .then(function () {
        fitNameInputs();
        scheduleRender();
      })
      .catch(scheduleRender);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready
        .then(function () {
          fitNameInputs();
          scheduleRender();
        })
        .catch(function () {});
    }

    if (window.ResizeObserver && elements.artBoard) {
      nameResizeObserver = new ResizeObserver(fitNameInputs);
      nameResizeObserver.observe(elements.artBoard);
    }
  }

  function bindEvents() {
    elements.form.addEventListener("submit", function (event) {
      event.preventDefault();
      downloadPoster();
    });

    elements.firstName.addEventListener("input", function () {
      state.firstName = cleanName(elements.firstName.value);
      clearMessages();
      fitNameInputs();
      scheduleRender();
    });

    elements.lastName.addEventListener("input", function () {
      state.lastName = cleanName(elements.lastName.value);
      clearMessages();
      fitNameInputs();
      scheduleRender();
    });

    if (elements.photoHotspot) {
      elements.photoHotspot.addEventListener("click", openPhotoSheet);
    }

    elements.uploadButton.addEventListener("click", function () {
      closeCamera();
      elements.fileInput.click();
    });

    elements.cameraButton.addEventListener("click", function () {
      openCamera();
    });

    elements.fileInput.addEventListener("change", function () {
      loadSelectedFile(elements.fileInput);
    });

    elements.captureInput.addEventListener("change", function () {
      loadSelectedFile(elements.captureInput);
    });

    elements.zoom.addEventListener("input", function () {
      dismissCropHint(true);
      state.crop.scale = clamp(Number(elements.zoom.value) || 1, 1, 2.8);
      clampCropToPosterBox();
      renderCropPreview();
      scheduleRender();
    });

    elements.resetCrop.addEventListener("click", function () {
      state.crop.x = 0;
      state.crop.y = 0;
      state.crop.scale = 1;
      elements.zoom.value = "1";
      renderCropPreview();
      scheduleRender();
    });

    elements.download.addEventListener("click", downloadPoster);
    elements.share.addEventListener("click", sharePoster);

    if (elements.copy) {
      elements.copy.addEventListener("click", copyPoster);
    }

    elements.cropCanvas.addEventListener("pointerdown", beginCropDrag);
    elements.cropCanvas.addEventListener("pointermove", moveCropDrag);
    elements.cropCanvas.addEventListener("pointerup", endCropDrag);
    elements.cropCanvas.addEventListener("pointercancel", endCropDrag);
    elements.cropCanvas.addEventListener("lostpointercapture", endCropDrag);

    if (elements.captureButton) {
      elements.captureButton.addEventListener("click", captureCameraFrame);
    }

    document.querySelectorAll("[data-camera-close]").forEach(function (button) {
      button.addEventListener("click", closeCamera);
    });

    document.querySelectorAll("[data-photo-close]").forEach(function (button) {
      button.addEventListener("click", closePhotoSheet);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }

      if (elements.cameraSheet && !elements.cameraSheet.hidden) {
        closeCamera();
        return;
      }

      if (elements.photoSheet && !elements.photoSheet.hidden) {
        closePhotoSheet();
      }
    });

    window.addEventListener("pagehide", stopCamera);
    window.addEventListener("beforeunload", stopCamera);
    window.addEventListener("resize", fitNameInputs);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stopCamera();
      }
    });
  }

  async function loadStaticAssets() {
    const entries = Object.entries(assetPaths);
    const results = await Promise.allSettled(
      entries.map(function ([name, path]) {
        return loadCanvasImage(path).then(function (image) {
          return [name, image];
        });
      })
    );

    results.forEach(function (result) {
      if (result.status === "fulfilled") {
        const pair = result.value;
        state.assets[pair[0]] = pair[1];
      }
    });
  }

  function loadCanvasImage(src) {
    return new Promise(function (resolve, reject) {
      const image = new Image();
      image.decoding = "async";
      image.onload = function () {
        resolve(image);
      };
      image.onerror = reject;
      image.src = src;
    });
  }

  async function loadSelectedFile(input) {
    const file = input.files && input.files[0];
    input.value = "";
    if (!file) {
      return;
    }
    await loadImageFromFile(file);
  }

  async function loadImageFromFile(file) {
    clearMessages();
    closeCamera();

    if (!file || !file.type || !file.type.startsWith("image/")) {
      showError(messages.imageLoadError);
      return;
    }

    try {
      const decoded = await decodeImageFile(file);
      const resized = resizeImageSource(decoded);

      state.image = resized.source;
      state.imageWidth = resized.width;
      state.imageHeight = resized.height;
      state.crop.x = 0;
      state.crop.y = 0;
      state.crop.scale = 1;
      state.cropHintDismissed = false;
      elements.zoom.value = "1";

      updateCropControls();
      renderCropPreview();
      showCropHint();
      fitNameInputs();
      scheduleRender();
      if (elements.photoSheet && elements.photoSheet.hidden) {
        openPhotoSheet();
      }
    } catch (error) {
      showError(messages.imageLoadError);
    }
  }

  async function decodeImageFile(file) {
    if (window.createImageBitmap) {
      try {
        return await createImageBitmap(file, { imageOrientation: "from-image" });
      } catch (error) {
        return decodeImageWithElement(file);
      }
    }

    return decodeImageWithElement(file);
  }

  function decodeImageWithElement(file) {
    return new Promise(function (resolve, reject) {
      const image = new Image();
      const objectUrl = URL.createObjectURL(file);

      image.onload = function () {
        URL.revokeObjectURL(objectUrl);
        resolve(image);
      };

      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("Image load failed."));
      };

      image.src = objectUrl;
    });
  }

  function resizeImageSource(source) {
    const width = getSourceWidth(source);
    const height = getSourceHeight(source);
    const largest = Math.max(width, height);

    if (!width || !height || largest <= MAX_IMAGE_DIMENSION) {
      return { source, width, height };
    }

    const scale = MAX_IMAGE_DIMENSION / largest;
    const targetWidth = Math.round(width * scale);
    const targetHeight = Math.round(height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = targetWidth;
    canvas.height = targetHeight;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(source, 0, 0, targetWidth, targetHeight);

    if (typeof source.close === "function") {
      source.close();
    }

    return { source: canvas, width: targetWidth, height: targetHeight };
  }

  async function openCamera() {
    clearMessages();
    stopCamera();

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      showError(messages.cameraUnavailable);
      elements.captureInput.click();
      return;
    }

    elements.cameraSheet.hidden = false;
    syncModalState();

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: false,
      });

      state.cameraStream = stream;
      elements.cameraVideo.srcObject = stream;
      await elements.cameraVideo.play();
    } catch (error) {
      closeCamera();
      showError(
        error && error.name === "NotAllowedError"
          ? messages.cameraPermissionError
          : messages.cameraUnavailable
      );
      elements.captureInput.click();
    }
  }

  async function captureCameraFrame() {
    if (!elements.cameraVideo.videoWidth || !elements.cameraVideo.videoHeight) {
      showError(messages.genericError);
      return;
    }

    const canvas = document.createElement("canvas");
    canvas.width = elements.cameraVideo.videoWidth;
    canvas.height = elements.cameraVideo.videoHeight;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(elements.cameraVideo, 0, 0, canvas.width, canvas.height);

    try {
      const blob = await canvasToBlob(canvas);
      const file = new File([blob], "zonilive-student-photo.png", {
        type: "image/png",
      });
      closeCamera();
      await loadImageFromFile(file);
      openPhotoSheet();
    } catch (error) {
      showError(messages.genericError);
    }
  }

  function openPhotoSheet() {
    if (!elements.photoSheet) {
      return;
    }

    clearMessages();
    closeCamera();
    elements.photoSheet.hidden = false;
    syncModalState();
    renderCropPreview();
    showCropHint();

    window.setTimeout(function () {
      if (state.image && elements.zoom) {
        elements.zoom.focus();
        return;
      }

      if (elements.uploadButton) {
        elements.uploadButton.focus();
      }
    }, 0);
  }

  function closePhotoSheet() {
    if (!elements.photoSheet) {
      return;
    }

    elements.photoSheet.hidden = true;
    closeCamera();
    hideCropHint(false);
    syncModalState();

    if (elements.photoHotspot) {
      elements.photoHotspot.focus();
    }
  }

  function closeCamera() {
    stopCamera();
    elements.cameraSheet.hidden = true;
    syncModalState();
  }

  function syncModalState() {
    const isPhotoOpen = elements.photoSheet && !elements.photoSheet.hidden;
    const isCameraOpen = elements.cameraSheet && !elements.cameraSheet.hidden;
    document.body.classList.toggle(
      "social-share-modal-open",
      Boolean(isPhotoOpen || isCameraOpen)
    );
  }

  function stopCamera() {
    if (state.cameraStream) {
      state.cameraStream.getTracks().forEach(function (track) {
        track.stop();
      });
      state.cameraStream = null;
    }

    if (elements.cameraVideo) {
      elements.cameraVideo.pause();
      elements.cameraVideo.srcObject = null;
    }
  }

  function beginCropDrag(event) {
    if (!state.image) {
      return;
    }

    state.pointer.active = true;
    state.pointer.lastX = event.clientX;
    state.pointer.lastY = event.clientY;
    dismissCropHint(true);
    elements.cropCanvas.setPointerCapture(event.pointerId);
  }

  function moveCropDrag(event) {
    if (!state.pointer.active || !state.image) {
      return;
    }

    const rect = elements.cropCanvas.getBoundingClientRect();
    const cropScale = POSTER.portraitBox.w / Math.max(rect.width, 1);
    const dx = (event.clientX - state.pointer.lastX) * cropScale;
    const dy = (event.clientY - state.pointer.lastY) * cropScale;

    state.pointer.lastX = event.clientX;
    state.pointer.lastY = event.clientY;
    state.crop.x += dx;
    state.crop.y += dy;

    clampCropToPosterBox();
    renderCropPreview();
    scheduleRender();
  }

  function endCropDrag() {
    state.pointer.active = false;
  }

  function updateCropControls() {
    const hasImage = Boolean(state.image);
    elements.zoom.disabled = !hasImage;
    elements.resetCrop.disabled = !hasImage;
    root.classList.toggle("has-student-photo", hasImage);
    if (!hasImage) {
      hideCropHint(true);
    }
  }

  function showCropHint() {
    if (!state.image || state.cropHintDismissed || !elements.cropHint) {
      return;
    }

    window.clearTimeout(state.cropHintTimer);
    elements.cropHint.hidden = false;
    elements.cropHint.classList.remove("is-visible");

    window.requestAnimationFrame(function () {
      const cropWrap = elements.cropHint.closest(".social-share-crop-wrap");
      if (cropWrap) {
        cropWrap.classList.add("is-guiding-crop");
      }
      elements.cropHint.classList.add("is-visible");
    });

    state.cropHintTimer = window.setTimeout(function () {
      hideCropHint(false);
    }, 6200);
  }

  function dismissCropHint(remember) {
    if (remember) {
      state.cropHintDismissed = true;
    }
    hideCropHint(false);
  }

  function hideCropHint(force) {
    if (!elements.cropHint) {
      return;
    }

    window.clearTimeout(state.cropHintTimer);
    state.cropHintTimer = null;
    elements.cropHint.classList.remove("is-visible");

    const cropWrap = elements.cropHint.closest(".social-share-crop-wrap");
    if (cropWrap) {
      cropWrap.classList.remove("is-guiding-crop");
    }

    if (force) {
      elements.cropHint.hidden = true;
      return;
    }

    window.setTimeout(function () {
      if (!elements.cropHint.classList.contains("is-visible")) {
        elements.cropHint.hidden = true;
      }
    }, 240);
  }

  function fitNameInputs() {
    if (
      !elements.firstName ||
      !elements.lastName ||
      !elements.nameEditor ||
      !elements.artBoard ||
      !nameFitCtx
    ) {
      return;
    }

    const boardWidth = elements.artBoard.clientWidth || 430;
    const posterScale = boardWidth / POSTER.width;
    const baseSize = clamp(Math.round(96 * posterScale), 22, 38);
    const minSize = clamp(Math.round(36 * posterScale), 16, baseSize);
    const availableWidth = Math.max(elements.nameEditor.clientWidth - 16, 40);
    const style = window.getComputedStyle(elements.firstName);
    const values = [elements.firstName, elements.lastName].map(function (input) {
      return cleanName(input.value) || input.getAttribute("placeholder") || "";
    });
    let size = baseSize;

    while (size > minSize) {
      nameFitCtx.font = `${style.fontWeight} ${size}px ${style.fontFamily}`;
      const widest = values.reduce(function (max, value) {
        return Math.max(max, nameFitCtx.measureText(value).width);
      }, 0);

      if (widest <= availableWidth) {
        break;
      }
      size -= 1;
    }

    const nameTop = 654 * posterScale;
    const opportunityTop = 886 * posterScale;
    const safetyGap = Math.max(8 * posterScale, 4);
    const maxLineHeight = Math.max((opportunityTop - nameTop - safetyGap) / 2, minSize);
    const lineHeight = Math.min(Math.round(size * 1.08), Math.floor(maxLineHeight));
    const resolvedSize = Math.min(size, Math.max(16, Math.floor(lineHeight / 1.04)));

    elements.nameEditor.style.setProperty(
      "--social-share-name-font-size",
      `${resolvedSize}px`
    );
    elements.nameEditor.style.setProperty(
      "--social-share-name-line-height",
      `${lineHeight}px`
    );
  }

  function scheduleRender() {
    if (state.renderPending) {
      return;
    }

    state.renderPending = true;
    requestAnimationFrame(function () {
      state.renderPending = false;
      renderPoster({ includeEditableName: false });
    });
  }

  function renderPoster(options) {
    const includeEditableName = Boolean(options && options.includeEditableName);
    const ctx = previewCtx;
    ctx.save();
    ctx.clearRect(0, 0, POSTER.width, POSTER.height);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    drawBackground(ctx);
    drawLogo(ctx);
    drawPortrait(ctx, includeEditableName);
    drawOpportunity(ctx);
    drawSpecificPurposesBadge(ctx);
    drawCoursePanel(ctx);
    drawQuote(ctx);
    drawFooterChips(ctx);

    ctx.restore();
  }

  function drawBackground(ctx) {
    if (state.assets.background) {
      ctx.drawImage(state.assets.background, 0, 0, POSTER.width, POSTER.height);
      return;
    }

    const gradient = ctx.createLinearGradient(0, 0, 0, POSTER.height);
    gradient.addColorStop(0, "#02081f");
    gradient.addColorStop(0.52, "#061763");
    gradient.addColorStop(1, "#02051d");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, POSTER.width, POSTER.height);
    ctx.strokeStyle = "#ffd795";
    ctx.lineWidth = 6;
    roundedRect(ctx, 52, 60, 976, 1794, 36);
    ctx.stroke();
  }

  function drawLogo(ctx) {
    if (state.assets.logo) {
      ctx.drawImage(state.assets.logo, 337, 103, 419, 114);
    } else {
      ctx.font = "900 76px Poppins, Arial, sans-serif";
      ctx.fillStyle = "#ffffff";
      ctx.textAlign = "center";
      ctx.fillText("ZONI", 500, 185);
      ctx.fillStyle = "#ef3e42";
      ctx.font = "italic 700 72px Poppins, Arial, sans-serif";
      ctx.fillText("Live", 655, 185);
    }
  }

  function drawPortrait(ctx, includeEditableName) {
    const centerX = 540;
    const centerY = 460;
    const outerRadius = 174;
    const innerRadius = 150;

    ctx.save();
    ctx.shadowColor = "rgba(0, 207, 255, 0.35)";
    ctx.shadowBlur = 18;
    ctx.fillStyle = "#f7fbff";
    ctx.beginPath();
    ctx.arc(centerX, centerY, outerRadius, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    ctx.save();
    ctx.strokeStyle = "#03a9ff";
    ctx.lineWidth = 7;
    ctx.beginPath();
    ctx.arc(centerX, centerY, outerRadius - 3, 0, Math.PI * 2);
    ctx.stroke();
    ctx.restore();

    const photoBox = {
      x: centerX - innerRadius,
      y: centerY - innerRadius,
      w: innerRadius * 2,
      h: innerRadius * 2,
    };

    if (state.image) {
      drawCoverImage(ctx, state.image, photoBox, state.crop, true);
    } else {
      drawPhotoPlaceholder(ctx, photoBox, getInitials());
    }

    if (state.assets.verifiedOutline) {
      ctx.drawImage(state.assets.verifiedOutline, 683, 289, 73, 73);
    } else {
      drawVerifiedMark(ctx, 720, 326, 34);
    }

    if (includeEditableName) {
      drawStudentName(ctx);
    }
  }

  function drawStudentName(ctx) {
    const first = state.firstName || "First Name";
    const last = state.lastName || "Last Name";
    const lines = [first, last].filter(Boolean);
    const maxWidth = 760;
    let size = 96;
    let widest = 0;

    while (size > 36) {
      ctx.font = `300 ${size}px Poppins, Barlow, Arial, sans-serif`;
      widest = lines.reduce(function (max, line) {
        return Math.max(max, ctx.measureText(line).width);
      }, 0);

      if (widest <= maxWidth) {
        break;
      }
      size -= 2;
    }

    ctx.font = `300 ${size}px Poppins, Barlow, Arial, sans-serif`;
    widest = lines.reduce(function (max, line) {
      return Math.max(max, ctx.measureText(line).width);
    }, 0);

    const lineHeight = size * 1.08;
    const top = lines.length > 1 ? 654 : 696;
    const textScaleX = Math.min(1, maxWidth / Math.max(widest, 1));

    ctx.save();
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.textBaseline = "alphabetic";
    ctx.font = `300 ${size}px Poppins, Barlow, Arial, sans-serif`;
    lines.forEach(function (line, index) {
      ctx.save();
      ctx.translate(540, top + size + index * lineHeight);
      ctx.scale(textScaleX, 1);
      ctx.fillText(line, 0, 0);
      ctx.restore();
    });
    ctx.restore();
  }

  function drawOpportunity(ctx) {
    ctx.save();
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.textBaseline = "alphabetic";
    ctx.font = "700 32px Poppins, Arial, sans-serif";
    ctx.fillText("HAS BEEN SELECTED FOR A SPECIAL", 540, 918);
    ctx.fillText("LEARNING OPPORTUNITY FROM ZONILIVE.", 540, 956);
    ctx.restore();
  }

  function drawSpecificPurposesBadge(ctx) {
    const label = "English for Specific Purposes";
    const x = 244;
    const y = 1000;
    const width = 592;
    const height = 56;

    ctx.save();
    ctx.shadowColor = "rgba(0, 207, 255, 0.22)";
    ctx.shadowBlur = 18;
    ctx.fillStyle = "rgba(3, 13, 45, 0.72)";
    roundedRect(ctx, x, y, width, height, 28);
    ctx.fill();
    ctx.shadowBlur = 0;

    const borderGradient = ctx.createLinearGradient(x, y, x + width, y);
    borderGradient.addColorStop(0, "rgba(88, 231, 255, 0.7)");
    borderGradient.addColorStop(0.5, "rgba(255, 231, 184, 0.84)");
    borderGradient.addColorStop(1, "rgba(88, 231, 255, 0.7)");
    ctx.strokeStyle = borderGradient;
    ctx.lineWidth = 2;
    roundedRect(ctx, x + 1, y + 1, width - 2, height - 2, 27);
    ctx.stroke();

    ctx.fillStyle = "#ffe7b8";
    ctx.font = "700 30px Poppins, Arial, sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(label, x + width / 2, y + height / 2 + 1);

    ctx.fillStyle = "#58e7ff";
    ctx.beginPath();
    ctx.arc(x + 34, y + height / 2, 5, 0, Math.PI * 2);
    ctx.arc(x + width - 34, y + height / 2, 5, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  function drawCoursePanel(ctx) {
    ctx.save();
    ctx.strokeStyle = "rgba(38, 113, 190, 0.95)";
    ctx.lineWidth = 1.5;
    roundedRect(ctx, 96, 1105, 881, 425, 10);
    ctx.stroke();

    if (state.assets.verifiedChip) {
      ctx.drawImage(state.assets.verifiedChip, 837, 1124, 118, 73);
    }

    drawPanelIntro(ctx);
    drawCourseTitle(ctx);

    if (state.assets.ai) {
      ctx.drawImage(state.assets.ai, 630, 1222, 299, 168);
    } else {
      ctx.font = "900 116px Roboto, Poppins, Arial, sans-serif";
      ctx.fillStyle = "#00cfff";
      ctx.fillText("AI", 680, 1358);
    }

    ctx.font = "700 28px Poppins, Arial, sans-serif";
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "left";
    drawWrappedText(
      ctx,
      "designed to help committed students improve their English, develop future-ready skills, and move closer to their goals.",
      115,
      1415,
      851,
      35,
      3
    );

    ctx.restore();
  }

  function drawPanelIntro(ctx) {
    const first = state.firstName || "[First Name]";
    let size = 28;
    const text = `As an active ZoniLive student, ${first} will receive access to a`;

    while (size > 22) {
      ctx.font = `700 ${size}px Poppins, Arial, sans-serif`;
      if (wrapText(ctx, text, 655).length <= 3) {
        break;
      }
      size -= 1;
    }

    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "left";
    ctx.font = `700 ${size}px Poppins, Arial, sans-serif`;
    drawWrappedText(ctx, text, 124, 1135, 655, size * 1.26, 3);
  }

  function drawCourseTitle(ctx) {
    const lines = ["FREE 10-WEEK", "ENGLISH FOR AI", "COURSE"];
    const gradient = ctx.createLinearGradient(121, 1226, 545, 1395);
    gradient.addColorStop(0, "#00cfff");
    gradient.addColorStop(0.5, "#01c0ec");
    gradient.addColorStop(1, "#1909f4");

    ctx.save();
    ctx.fillStyle = gradient;
    ctx.textAlign = "left";
    ctx.textBaseline = "alphabetic";
    ctx.font = "900 58px Roboto, Poppins, Arial, sans-serif";
    lines.forEach(function (line, index) {
      ctx.fillText(line, 121, 1279 + index * 60);
    });
    ctx.restore();
  }

  function drawQuote(ctx) {
    ctx.save();
    ctx.strokeStyle = "#2671be";
    ctx.lineWidth = 4;
    roundedRect(ctx, 110, 1582, 881, 136, 10);
    ctx.stroke();

    ctx.fillStyle = "#ffffff";
    ctx.font = "italic 700 24px Barlow, Poppins, Arial, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("This is more than a course.", 550, 1632);
    ctx.fillText("It is a commitment to growth, success, and the", 550, 1660);
    ctx.fillText("future.", 550, 1688);
    ctx.restore();
  }

  function drawFooterChips(ctx) {
    drawFooterChip(ctx, 134, 1780, "ZONILIVE");
    drawFooterChip(ctx, 326, 1780, "ENGLISH FOR AI");
    drawFooterChip(ctx, 564, 1780, "FREE FOR ACTIVE ZONILIVE STUDENTS");
  }

  function drawFooterChip(ctx, x, y, label) {
    ctx.save();
    drawTinyCheck(ctx, x, y - 6);
    ctx.fillStyle = "#ffffff";
    ctx.font = "500 16px Poppins, Arial, sans-serif";
    ctx.textAlign = "left";
    ctx.fillText(label, x + 19, y);
    ctx.restore();
  }

  function drawTinyCheck(ctx, x, y) {
    ctx.save();
    ctx.strokeStyle = "#30ff66";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(x, y, 8, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x - 4, y);
    ctx.lineTo(x - 1, y + 3);
    ctx.lineTo(x + 5, y - 4);
    ctx.stroke();
    ctx.restore();
  }

  function drawPhotoPlaceholder(ctx, box, initials) {
    ctx.save();
    ctx.beginPath();
    ctx.arc(box.x + box.w / 2, box.y + box.h / 2, box.w / 2, 0, Math.PI * 2);
    ctx.clip();

    const gradient = ctx.createLinearGradient(box.x, box.y, box.x + box.w, box.y + box.h);
    gradient.addColorStop(0, "#d9ecff");
    gradient.addColorStop(1, "#ffffff");
    ctx.fillStyle = gradient;
    ctx.fillRect(box.x, box.y, box.w, box.h);

    ctx.fillStyle = "#0d5fa8";
    ctx.globalAlpha = 0.14;
    ctx.beginPath();
    ctx.arc(box.x + box.w / 2, box.y + box.h * 0.43, box.w * 0.18, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.ellipse(
      box.x + box.w / 2,
      box.y + box.h * 0.78,
      box.w * 0.3,
      box.h * 0.2,
      0,
      0,
      Math.PI * 2
    );
    ctx.fill();

    if (initials) {
      ctx.globalAlpha = 1;
      ctx.fillStyle = "#17324d";
      ctx.font = "700 70px Poppins, Arial, sans-serif";
      ctx.textAlign = "center";
      ctx.fillText(initials, box.x + box.w / 2, box.y + box.h / 2 + 25);
    }

    ctx.restore();
  }

  function drawVerifiedMark(ctx, x, y, radius) {
    ctx.save();
    ctx.strokeStyle = "#63ff57";
    ctx.lineWidth = 8;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x - 14, y);
    ctx.lineTo(x - 4, y + 10);
    ctx.lineTo(x + 18, y - 16);
    ctx.stroke();
    ctx.restore();
  }

  function renderCropPreview() {
    const ctx = cropCtx;
    ctx.save();
    ctx.clearRect(0, 0, CROP_CANVAS_SIZE, CROP_CANVAS_SIZE);

    const gradient = ctx.createLinearGradient(0, 0, CROP_CANVAS_SIZE, CROP_CANVAS_SIZE);
    gradient.addColorStop(0, "#071335");
    gradient.addColorStop(1, "#092c6d");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, CROP_CANVAS_SIZE, CROP_CANVAS_SIZE);

    const ringCenter = CROP_CANVAS_SIZE / 2;
    const innerRadius = 126;
    const photoBox = {
      x: ringCenter - innerRadius,
      y: ringCenter - innerRadius,
      w: innerRadius * 2,
      h: innerRadius * 2,
    };

    ctx.fillStyle = "#f7fbff";
    ctx.beginPath();
    ctx.arc(ringCenter, ringCenter, 146, 0, Math.PI * 2);
    ctx.fill();

    ctx.strokeStyle = "#03a9ff";
    ctx.lineWidth = 5;
    ctx.beginPath();
    ctx.arc(ringCenter, ringCenter, 143, 0, Math.PI * 2);
    ctx.stroke();

    if (state.image) {
      const ratio = photoBox.w / POSTER.portraitBox.w;
      const crop = {
        x: state.crop.x * ratio,
        y: state.crop.y * ratio,
        scale: state.crop.scale,
      };
      drawCoverImage(ctx, state.image, photoBox, crop, true);
    } else {
      drawPhotoPlaceholder(ctx, photoBox, getInitials());
    }

    ctx.restore();
  }

  function drawCoverImage(ctx, image, box, crop, circleClip) {
    const layout = getCoverLayout(image, box, crop);

    ctx.save();
    if (circleClip) {
      ctx.beginPath();
      ctx.arc(box.x + box.w / 2, box.y + box.h / 2, box.w / 2, 0, Math.PI * 2);
      ctx.clip();
    }

    ctx.drawImage(image, layout.x, layout.y, layout.w, layout.h);
    ctx.restore();
  }

  function getCoverLayout(image, box, crop) {
    const width = getSourceWidth(image);
    const height = getSourceHeight(image);
    const baseScale = Math.max(box.w / width, box.h / height);
    const scale = baseScale * clamp(crop.scale || 1, 1, 2.8);
    const drawWidth = width * scale;
    const drawHeight = height * scale;
    const maxX = Math.max(0, (drawWidth - box.w) / 2);
    const maxY = Math.max(0, (drawHeight - box.h) / 2);
    const offsetX = clamp(crop.x || 0, -maxX, maxX);
    const offsetY = clamp(crop.y || 0, -maxY, maxY);

    return {
      x: box.x + (box.w - drawWidth) / 2 + offsetX,
      y: box.y + (box.h - drawHeight) / 2 + offsetY,
      w: drawWidth,
      h: drawHeight,
      offsetX,
      offsetY,
    };
  }

  function clampCropToPosterBox() {
    if (!state.image) {
      return;
    }

    const layout = getCoverLayout(state.image, POSTER.portraitBox, state.crop);
    state.crop.x = layout.offsetX;
    state.crop.y = layout.offsetY;
  }

  function drawWrappedText(ctx, text, x, top, maxWidth, lineHeight, maxLines) {
    const lines = wrapText(ctx, text, maxWidth).slice(0, maxLines || Infinity);
    lines.forEach(function (line, index) {
      const metrics = getFontSize(ctx.font);
      ctx.fillText(line, x, top + metrics + index * lineHeight);
    });
  }

  function wrapText(ctx, text, maxWidth) {
    const words = String(text || "").trim().split(/\s+/);
    const lines = [];
    let line = "";

    words.forEach(function (word) {
      const testLine = line ? `${line} ${word}` : word;
      if (ctx.measureText(testLine).width <= maxWidth || !line) {
        line = testLine;
      } else {
        lines.push(line);
        line = word;
      }
    });

    if (line) {
      lines.push(line);
    }

    return lines;
  }

  function roundedRect(ctx, x, y, width, height, radius) {
    const r = Math.min(radius, width / 2, height / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  async function downloadPoster() {
    if (!(await prepareExport())) {
      return;
    }

    try {
      setExporting(true);
      renderPoster({ includeEditableName: true });
      const blob = await canvasToBlob(elements.previewCanvas);
      triggerDownload(blob);
      showStatus(messages.downloadReady);
    } catch (error) {
      showError(messages.genericError);
    } finally {
      setExporting(false);
      scheduleRender();
    }
  }

  async function sharePoster() {
    if (!(await prepareExport())) {
      return;
    }

    try {
      setExporting(true);
      renderPoster({ includeEditableName: true });
      const blob = await canvasToBlob(elements.previewCanvas);
      const file = new File([blob], getPosterFileName(), { type: "image/png" });
      const shareData = {
        files: [file],
        title: "Spotlight",
        text: "Spotlight image",
      };

      if (
        navigator.share &&
        navigator.canShare &&
        navigator.canShare({ files: [file] })
      ) {
        await navigator.share(shareData);
        return;
      }

      showStatus(messages.shareUnavailable);
      triggerDownload(blob);
    } catch (error) {
      if (error && error.name === "AbortError") {
        return;
      }
      showError(messages.genericError);
    } finally {
      setExporting(false);
      scheduleRender();
    }
  }

  async function copyPoster() {
    if (!(await prepareExport())) {
      return;
    }

    if (!canCopyImageToClipboard()) {
      showStatus(messages.copyUnavailable);
      updateCopyAvailability();
      return;
    }

    try {
      setExporting(true);
      renderPoster({ includeEditableName: true });
      const blob = await canvasToBlob(elements.previewCanvas);
      await navigator.clipboard.write([
        new ClipboardItem({
          "image/png": blob,
        }),
      ]);
      showStatus(messages.copySuccess);
    } catch (error) {
      showStatus(messages.copyUnavailable);
    } finally {
      setExporting(false);
      scheduleRender();
    }
  }

  function updateCopyAvailability() {
    if (!elements.copy) {
      return;
    }

    const isAvailable = canCopyImageToClipboard();
    elements.copy.hidden = !isAvailable;
    elements.copy.setAttribute("aria-hidden", isAvailable ? "false" : "true");
    elements.copy.disabled = !isAvailable || state.exporting;
  }

  function canCopyImageToClipboard() {
    // Safari/WebKit can expose image clipboard APIs while rejecting this async
    // canvas-to-PNG write path, especially on iPhone and iPad.
    if (isIOSDevice() || isSafariBrowser()) {
      return false;
    }

    if (
      !window.isSecureContext ||
      !navigator.clipboard ||
      typeof navigator.clipboard.write !== "function" ||
      !window.ClipboardItem
    ) {
      return false;
    }

    if (
      typeof ClipboardItem.supports === "function" &&
      !ClipboardItem.supports("image/png")
    ) {
      return false;
    }

    try {
      new ClipboardItem({
        "image/png": new Blob([], { type: "image/png" }),
      });
    } catch (error) {
      return false;
    }

    return true;
  }

  function isIOSDevice() {
    const userAgent = navigator.userAgent || "";
    const platform = navigator.platform || "";
    return (
      /iPad|iPhone|iPod/.test(userAgent) ||
      (platform === "MacIntel" && Number(navigator.maxTouchPoints) > 1)
    );
  }

  function isSafariBrowser() {
    const userAgent = navigator.userAgent || "";
    const vendor = navigator.vendor || "";
    return (
      /Safari/i.test(userAgent) &&
      /Apple/i.test(vendor) &&
      !/(Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android)/i.test(userAgent)
    );
  }

  async function prepareExport() {
    clearMessages();

    if (!validateInputs()) {
      return false;
    }

    try {
      await assetsPromise;
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }
    } catch (error) {
      // The renderer has fallbacks for missing assets and fonts.
    }

    return true;
  }

  function validateInputs() {
    state.firstName = cleanName(elements.firstName.value);
    state.lastName = cleanName(elements.lastName.value);

    if (!state.firstName) {
      showError(messages.firstNameRequired);
      elements.firstName.focus();
      return false;
    }

    if (!state.lastName) {
      showError(messages.lastNameRequired);
      elements.lastName.focus();
      return false;
    }

    if (!state.image) {
      openPhotoSheet();
      showError(messages.photoRequired);
      if (elements.uploadButton) {
        elements.uploadButton.focus();
      }
      return false;
    }

    return true;
  }

  function canvasToBlob(canvas) {
    return new Promise(function (resolve, reject) {
      if (!canvas.toBlob) {
        try {
          resolve(dataUrlToBlob(canvas.toDataURL("image/png")));
        } catch (error) {
          reject(error);
        }
        return;
      }

      canvas.toBlob(function (blob) {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error("Canvas export failed."));
        }
      }, "image/png");
    });
  }

  function dataUrlToBlob(dataUrl) {
    const parts = dataUrl.split(",");
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const binary = atob(parts[1]);
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new Blob([bytes], { type: mime });
  }

  function triggerDownload(blob) {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = getPosterFileName();
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(function () {
      URL.revokeObjectURL(objectUrl);
    }, 250);
  }

  function getPosterFileName() {
    const first = slugify(state.firstName || "student");
    const last = slugify(state.lastName || "zonilive");
    return `my-zonilive-spotlight-${first}-${last}.png`;
  }

  function setExporting(isExporting) {
    state.exporting = isExporting;
    [elements.download, elements.share, elements.copy].forEach(function (button) {
      if (button) {
        button.disabled = isExporting || (button === elements.copy && !canCopyImageToClipboard());
      }
    });
  }

  function showError(message) {
    if (elements.alert) {
      elements.alert.textContent = safeMessage(message) || messages.genericError;
    }
    if (elements.status) {
      elements.status.textContent = "";
    }
  }

  function showStatus(message) {
    if (elements.status) {
      elements.status.textContent = safeMessage(message);
    }
    if (elements.alert) {
      elements.alert.textContent = "";
    }
  }

  function clearMessages() {
    if (elements.alert) {
      elements.alert.textContent = "";
    }
    if (elements.status) {
      elements.status.textContent = "";
    }
  }

  function safeMessage(message) {
    const value = String(message || "").trim();
    if (!value) {
      return "";
    }
    if (
      value.includes("Traceback") ||
      value.includes("frappe.") ||
      value.includes("File \"")
    ) {
      return "";
    }
    return value;
  }

  function cleanName(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function getInitials() {
    const first = state.firstName || elements.firstName.value || "";
    const last = state.lastName || elements.lastName.value || "";
    return `${first.charAt(0)}${last.charAt(0)}`.trim().toUpperCase();
  }

  function slugify(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 48);
  }

  function getSourceWidth(source) {
    return source.width || source.naturalWidth || source.videoWidth || 0;
  }

  function getSourceHeight(source) {
    return source.height || source.naturalHeight || source.videoHeight || 0;
  }

  function getFontSize(font) {
    const match = String(font || "").match(/(\d+(?:\.\d+)?)px/);
    return match ? Number(match[1]) : 16;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
})();
